module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_02.9443de20.jpg";